import React from 'react';
import { useObservable } from 'react-use-observable';

import { Typography } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import affiliateService from 'v2/services/affiliate';

import { Export } from './Export';

const Details = () => {
  const [totalItems] = useObservable(() => affiliateService.getTotalItems(), []);
  const [loading] = useObservable(() => affiliateService.isLoading(), []);

  return (
    <div id='affiliates-details' className='mb-6 flex flex-wrap items-center justify-between gap-3'>
      <Typography.Text id='affiliates-result-button-label' data-testid='affiliates-result-label' strong>
        {totalItems || 0} solicitações
      </Typography.Text>
      <PermissionHide action={'myeduzz:meus-afiliados:editar'}>{!loading && <Export />}</PermissionHide>
    </div>
  );
};

export default Details;
